import { render, staticRenderFns } from "./CreateCoupon.vue?vue&type=template&id=53fa5842&scoped=true"
import script from "./CreateCoupon.vue?vue&type=script&lang=js"
export * from "./CreateCoupon.vue?vue&type=script&lang=js"
import style0 from "./CreateCoupon.vue?vue&type=style&index=0&id=53fa5842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fa5842",
  null
  
)

export default component.exports